<template>
  <tr>
    <td>{{ packageNames || '--' }}</td>
    <td>{{ item.sum | money }}</td>
    <td>{{ payedTotal | money }}</td>
    <td>{{ restSum }}</td>
    <td>{{ pricePerMonth | money }}</td>
  </tr>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  computed: {
    packageNames() {
      const getName = (item) => item.package.name;
      const str = this.item.packages.map(getName);
      return str.join(', ');
    },
    payedTotal() {
      return this.item.payed_total || 0;
    },
    restSum() {
      const rest = this.item.sum - this.payedTotal;
      return rest === 0 ? '--' : this.$options.filters.money(rest);
    },
    pricePerMonth() {
      if (this.restSum === '--' || parseFloat(this.restSum) <= 0) return '--';
      const price = Number(this.item.price_per_month);
      return Number.isNaN(price) || price === 0 ? '--' : price;
    },
  },
};
</script>
